export const StepProgress = ({ steps = 5, currentStep }) => {
  return (
    <div className='step-progress-container'>
      {steps.map((_, index) => (
        <div key={index} className='step-wrapper'>
          {/* Step Line (before circle) */}
          {index > 0 && (
            <div
              className={`step-line ${index <= currentStep ? 'active' : ''}`}
            />
          )}

          {/* Step Circle */}
          <div
            className={`step-circle ${
              index <= currentStep - 1 ? 'active' : ''
            }`}
          />

          {/* Step Line (after circle) */}
          {index !== steps.length - 1 && (
            <div
              className={`step-line ${index < currentStep ? 'active' : ''}`}
            />
          )}
        </div>
      ))}
    </div>
  );
};
